import commonService from "./common-service";

class OrderService {
  async getPatientsList(search = "", limit = 20, url = null) {
    try {
      const requestUrl =
        url || `Remote/v1/Patients/List?search=${search}&limit=${limit}`;
  
      const response = await commonService.getFromServer(requestUrl);
  
      if (response) {
        return {
          list: response?.response || [],
          nextUrl: response?.nextUrl || null,
        };
      } else {
        throw new Error("Error loading patients");
      }
    } catch (e) {
      throw new Error(e?.message || "Error loading patients");
    }
  }
  async getPatients(search) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Patients?search=" + search,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getPatientsByFacID(id) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Patients?fac_id=" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getFrequency(search) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Frequencies",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDrugs(search) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Drugs?search=" + search,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDoctors(search, facility) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Doctors?search=" + search + "&fac_id=" + facility,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getFacilities(search) {
    try {
      const response = await commonService.getFromServer(
        "Remote/Facilities?search=" + search,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getFacilitiesForRefills(search) {
    try {
      const response = await commonService.getFromServer(
        "Remote/RefillDueFacilities?search=" + search,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getFaciltyRefillsDue(list, filter) {
    try {
      const response = await commonService.postToServer(
        `Remote/FacilityRefillDue?filter=${filter}`,
        list
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createOrder(params) {
    try {
      var response = await commonService.postToServer(
        "Remote/NewOrders",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async deletePatient(id) {
    try {
      const response = await commonService.deleteToServer("Patient/" + id, {});

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting drug");
      }
    } catch (e) {
      throw new Error("Error deleting drug");
    }
  }
  async getPatient(id) {
    try {
      const response = await commonService.getFromServer(
        "PatientProfile/Patients",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getPatientDrugs(pat_id) {
    try {
      const response = await commonService.getFromServer(
        "PatientProfile/Drugs?pat_id=" + pat_id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getVerifyRefills(list) {
    try {
      const response = await commonService.postToServer(
        "Remote/Refills/Verify",
        list
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitRefills(list) {
    try {
      const response = await commonService.postToServer(
        "Remote/Refills/Submit",
        list
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getSubstituteDrugs(id) {
    try {
      const response = await commonService.postToServer(
        "Remote/Refills/Verify/" + id,
        {}
      );
     
      if (response) {
        return response?.filter(item => item.status === 'Y');
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getRefillsDue(filter) {
    try {
      const response = await commonService.getFromServer(
        "Remote/RefillDue?filter=" + filter,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitRefillsDue(list) {
    try {
      const response = await commonService.postToServer(
        "Remote/RefillDue/Submit",
        list
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitForm(id, action) {
    try {
      const response = await commonService.postToServer("Remote/NonForms", {
        action: action,
        rxf_con_id: id,
      });
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitSuggestion( id, data) {
    try {
      const response = await commonService.updateToServer("Remote/Comments/"+id, data);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getNonFormsComments() {
    try {
      const response = await commonService.getFromServer("Remote/Comments", {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
      // return [{"id":33}]
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getNonForms() {
    try {
      const response = await commonService.getFromServer("Remote/NonForms", {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
      // return [{"id":33}]
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getRemoteDefaults() {
    try {
      const response = await commonService.getFromServer(
        "Remote/Defaults",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getPatientAllergies(patientId) {
    try {
      const response = await commonService.getFromServer(
        "Remote/PatientAllergies/" + patientId,
        {}
      );
      if (response) {
        return Array.isArray(response) ? response : [];
      } else {
        return [];
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getNonFormQuestionnaire(facId, drgId) {
    try {
      const response = await commonService.getFromServer(
        `Remote/NonFormQuestionnaire?fac_id=${facId}&drg_id=${drgId}`,
        {}
      );
      if (response) {
        return response;
      } else {
        return { isNonForm: false };
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async createNonFormOrder(params) {
    try {
      const response = await commonService.postToServer(
        "Remote/NonFormOrder",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error creating non-form order");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}
export default new OrderService();